module.exports = __webpack_public_path__ + "static/media/forwardIcon.368b5e15.svg";